import { render, staticRenderFns } from "./cTableItem.vue?vue&type=template&id=48be6057&scoped=true&"
import script from "./cTableItem.vue?vue&type=script&lang=js&"
export * from "./cTableItem.vue?vue&type=script&lang=js&"
import style0 from "./cTableItem.vue?vue&type=style&index=0&id=48be6057&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be6057",
  null
  
)

export default component.exports